import {
  isComparisonMode,
  isNotComparisonMode,
  showAllComparisonMode,
} from '../utils/comparison-mode-options'
import { filters } from '../constants'
import { workflowFilterLabel } from './shared'

export const workflowSharingStatusDefinition = {
  type: filters.WORKFLOW_SHARING_STATUS,
  nameKey: 'workflow_sharing_status',
  ledgerRequired: true,
  hasModalHelp: true,

  comparisonModes() {
    return [
      ...isComparisonMode({
        customLabel: I18n.t(
          'companies_overview.filters.workflow_sharing_status.is_shared'
        ),
      }),
      ...isNotComparisonMode({
        customLabel: I18n.t(
          'companies_overview.filters.workflow_sharing_status.is_not_shared'
        ),
      }),
      ...showAllComparisonMode({
        customLabel: I18n.t(
          'companies_overview.filters.workflow_sharing_status.show_all'
        ),
      }),
    ]
  },
  serializeSettings(settings) {
    const { comparisonMode, firmWorkflowId, partnerWorkflowId } = settings

    return {
      comparison_mode: comparisonMode,
      firm_workflow_id: firmWorkflowId,
      partner_workflow_id: partnerWorkflowId,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      firmWorkflowId: params.firm_workflow_id,
      partnerWorkflowId: params.partner_workflow_id,
    }
  },

  activeSubtitle(settings, getters) {
    const { comparisonMode } = settings

    const workflowLabel = workflowFilterLabel(settings, getters)

    const comparisonModeLabel = this.comparisonModes().find(
      (mode) => mode.value === comparisonMode
    ).label

    return `${workflowLabel} ${comparisonModeLabel}`
  },
}
